import * as Yup from 'yup';

const endAfterStartTest = (message: string) =>
  Yup.string()
    .required('Bitiş tarihi gereklidir')
    .test('after-start', message, function (value) {
      const { startDate } = this.parent as { startDate?: string };
      if (!startDate || !value) {
        return true;
      }
      return new Date(value).getTime() > new Date(startDate).getTime();
    });

export const OvertimeFormSchema = Yup.object({
  startDate: Yup.string().required('Başlangıç tarihi gereklidir'),
  endDate: endAfterStartTest('Bitiş tarihi başlangıç tarihinden sonra olmalıdır'),
  description: Yup.string().trim().required('Açıklama gereklidir'),
});

export const EditOvertimeFormSchema = OvertimeFormSchema.shape({
  status: Yup.string().oneOf(['Pending', 'Approved', 'Rejected']).optional(),
  rejectionReason: Yup.string().when('status', {
    is: 'Rejected',
    then: schema => schema.trim().required('Red sebebi gereklidir'),
    otherwise: schema => schema.optional(),
  }),
});
